import * as React from "react";
import classnames from "classnames";
import { CLStockIndicator } from "../../../../../../../../CLStockIndicator/modules/EcommContent/ContactLensesEcommContent/components/CLPrescriptionSelector/components/CLStockIndicator/CLStockIndicator.js";
import { CLQuantitySelectorContainer } from "../../../../../../../../CLQuantitySelector/modules/EcommContent/ContactLensesEcommContent/components/CLPrescriptionSelector/components/CLQuantitySelector/CLQuantitySelectorContainer.js";
const NoRxSelectionColumn = React.memo(
  ({ eyeSideId, className, "data-t": dataT }) => {
    return /* @__PURE__ */ React.createElement("div", { className: classnames("no-rx-selection-column", className), "data-t": dataT }, /* @__PURE__ */ React.createElement(
      CLQuantitySelectorContainer,
      {
        eyeSideId,
        className: "no-rx-selection-column__quantity-select",
        isEnabled: true
      }
    ), /* @__PURE__ */ React.createElement(CLStockIndicator, { eyeSideId, className: "no-rx-selection-column__stock" }));
  }
);
export {
  NoRxSelectionColumn
};
//# sourceMappingURL=NoRxSelectionColumn.js.map
